import { render, staticRenderFns } from "./PortfolioNavigation.vue?vue&type=template&id=5d2c8f16&"
import script from "./PortfolioNavigation.vue?vue&type=script&lang=js&"
export * from "./PortfolioNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports